$(document).ready(function() {



//   $('.footer-item__title').click(function() {
//     $('.footer-item__menu').slideUp(); // close all
//     $(this).next('.footer-item__menu').stop(true, true).slideToggle(); // toggle clicked one
//   });


   $('.footer-item__title').click(function() {
    let menu = $(this).next('.footer-item__menu');

    if (!menu.is(':visible')) {
      // close all menus + remove active
      $('.footer-item__menu').slideUp();
      $('.footer-item__title').removeClass('active');

      // open clicked one + add active
      menu.stop(true, true).slideDown();
      $(this).addClass('active');
    } else {
      // if open, close it and remove active
      menu.slideUp();
      $(this).removeClass('active');
    }
  });



});
